import { useTable, useExpanded } from 'react-table';
import useGetProjects from '../../../screens/ProjectListScreen/context/hooks/useGetProjects';
import { columns } from './table-config';
import { Wrapper } from './styles';
import { orderBy } from 'lodash';
import { useMemo } from 'react';

const ProjectListTable = ({ onEditProject, onOpenProjectIdCard, onCreateProjectIdCard, canCreateProjectIdCard }) => {
  const { projects } = useGetProjects();
  const sortedProjects = useMemo(() => orderBy(projects, ['number', 'name'], 'asc'), [projects]);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state: {expanded} } = useTable({
    columns,
    data: sortedProjects,
    isCatalogAdmin: canCreateProjectIdCard,
    onEditProject,
    onOpenProjectIdCard,
    onCreateProjectIdCard,
    autoResetExpanded: false,
  }, useExpanded);

  return (
    <Wrapper>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <>
                <tr key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
                {row.isExpanded && row.original.history.length > 0 && row.original.history.map(h =>
                    <tr className="historyItem">
                      <td>.</td>
                      <td>{h.number}</td>
                      <td>{h.name}</td>
                      <td>{h.location}</td>
                      <td>{h.client}</td>
                      <td>{h.oilFlowRate}</td>
                      <td>{h.gasRate}</td>
                      <td>{h.waterInjection}</td>
                      <td>{h.gasInjection}</td>
                      <td>{h.gasExport}</td>
                      <td>{h.date}</td>
                      <td></td>
                    </tr>)
                }
              </>
            );
          })}
        </tbody>
      </table>
    </Wrapper>
  );
};

export default ProjectListTable;
